webpackJsonp([0],{

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(50);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactStatic = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'Home__Container',
  componentId: 'hcdfsq-0'
})(['min-height:100vh;padding:4rem;max-width:90%;margin:0 auto;position:relative;']);

var Title = _styledComponents2.default.h1.withConfig({
  displayName: 'Home__Title',
  componentId: 'hcdfsq-1'
})(['font-size:30px;']);

var SubTitle = _styledComponents2.default.h2.withConfig({
  displayName: 'Home__SubTitle',
  componentId: 'hcdfsq-2'
})(['font-size:15px;margin-top:0.5rem;margin-bottom:2rem;']);

var Methods = _styledComponents2.default.div.withConfig({
  displayName: 'Home__Methods',
  componentId: 'hcdfsq-3'
})(['margin:2rem 0;']);

var Domains = _styledComponents2.default.div.withConfig({
  displayName: 'Home__Domains',
  componentId: 'hcdfsq-4'
})(['display:flex;flex-wrap:wrap;']);

var Domain = _styledComponents2.default.div.withConfig({
  displayName: 'Home__Domain',
  componentId: 'hcdfsq-5'
})(['display:inline-flex;align-items:center;justify-content:center;flex-direction:column;width:200px;height:200px;margin:0.5rem;padding:1rem;background:#eeeeee;border-radius:3px;h3{font-weight:bold;font-size:12px;text-transform:uppercase;margin-bottom:0.5rem;}']);

var Contact = _styledComponents2.default.a.withConfig({
  displayName: 'Home__Contact',
  componentId: 'hcdfsq-6'
})(['background-color:grey;color:white;font-size:13px;padding:2px 5px;border-radius:3px;position:absolute;top:2rem;right:2rem;']);

var domains = [{ name: 'blockout.io', desc: 'privacy' }, { name: 'psiblock.io', desc: 'Ψ' }, { name: 'sigmablock.io', desc: 'Σ' }, { name: 'gigablock.io', desc: '' }, { name: 'unmount.io', desc: '' }, { name: 'blockmaking.io', desc: '' }, { name: 'pillars.io', desc: '' }, { name: 'backblock.io', desc: '' }, { name: 'kiloblock.io', desc: '' }];

exports.default = (0, _reactStatic.withSiteData)(function () {
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(
      Title,
      null,
      'Crypto-related domains'
    ),
    _react2.default.createElement(
      SubTitle,
      null,
      'FOR SALE'
    ),
    _react2.default.createElement(
      Methods,
      null,
      'Using ',
      _react2.default.createElement(
        'span',
        { style: { color: '#EE9232' } },
        'Bitcoin'
      ),
      ',',
      ' ',
      _react2.default.createElement(
        'span',
        { style: { color: '#4B89E2' } },
        'Ethereum'
      ),
      ' or',
      ' ',
      _react2.default.createElement(
        'span',
        {
          style: {
            color: '#5EBA5E'
          }
        },
        'Escrow.com'
      ),
      '. ',
      _react2.default.createElement(
        Contact,
        { href: 'mailto:domainscrypto@protonmail.com' },
        'CONTACT US'
      )
    ),
    _react2.default.createElement(
      Domains,
      null,
      domains.map(function (domain) {
        return _react2.default.createElement(
          Domain,
          { key: domain.name },
          _react2.default.createElement(
            'h3',
            null,
            domain.name
          ),
          _react2.default.createElement(
            'span',
            null,
            domain.desc || '-'
          )
        );
      })
    )
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/components/Home.9062ec3b.js